<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2 mt-3">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Afficher</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filterInput"
                  type="search"
                  placeholder="Saisissez votre recherche"
                  @keyup="applyFilter"
                />
                <b-input-group-append>
                  <b-button
                    @click="applyFilterEnter"
                  >
                    Rechercher
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
          />
          <!-- Filter On -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              v-slot="{ ariaDescribedby }"
              v-model="sortDirection"
              description="Laissez tout décoché pour filtrer sur toutes les données"
              class="mt-0"
            >
              <b-form-checkbox-group
                v-model="filterOn"
                :aria-describedby="ariaDescribedby"
                class="mt-1 mb-0"
              >
                <b-form-checkbox
                  class="mb-1"
                  value="ref"
                >
                  Référence
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  value="nom"
                >
                  Nom
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  value="ville"
                >
                  Ville
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  value="pays"
                >
                  Pays
                </b-form-checkbox>
                <!-- <b-form-checkbox
                  class="mb-1"
                  value="phone"
                >
                  Téléphone
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  value="email"
                >
                  Email
                </b-form-checkbox> -->
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Tableau -->
        <b-row>
          <b-col cols="12">
            <b-table
              id="datatables"
              class="mt-4 mb-4"
              :items="clients"
              :fields="fields"
              stacked="md"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              striped
              small
              @filtered="onFiltered"
              @row-clicked="selectedCol"
            >

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  :to="{name: 'viewclient', params: { id: data.item.key }}"
                  variant="flat-success"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          />
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BImg,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        { key: 'ref', label: 'Référence', sortable: true },
        { key: 'nom', label: 'Nom', sortable: true },
        { key: 'ville', label: 'Ville', sortable: true  },
        { key: 'pays', label: 'Pays', sortable: true  },
      ],
      clients: [],
      isLoading: true,
      drawer: true,
      perPage: 100,
      currentPage: 1,
      totalRows: 1,
      filterInput: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: [],
      sortBy: 'ref',
      sortDirection: 'asc',
      sortDesc: false,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
      setting: JSON.parse(localStorage.setting),
      commercial: JSON.parse(localStorage.commercial),
      role: localStorage.getItem('role'),
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {},
  mounted() {},
  customButtons: {
    default: true,
  },
  created() {
    if(this.setting.filtre_clients_par_commerciaux == false || this.setting.filtre_clients_par_commerciaux == 'false' || this.role.includes('admin'+localStorage.getItem('database')) || this.role.includes('manager'+localStorage.getItem('database'))) {
      this.localDB.find({ selector: { type: 'clients' } }, this.setClients)
    }
    else {
      this.localDB.find({ selector: { type: 'clients', commerciaux: { $elemMatch : { $eq : localStorage.getItem('user') } } } }, this.setClients)
    }
  },
  methods: {
    setClients(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('doc', doc)
      const seenRefs = new Set()
      for (let i = 0; i < doc.docs.length; i++) {
        const ref = doc.docs[i].idclient
        if (seenRefs.has(ref)) continue
        seenRefs.add(ref)
        this.clients.push({
          key: doc.docs[i]._id,
          ref: doc.docs[i].idclient,
          nom: doc.docs[i].nom,
          adresse: doc.docs[i].adresses[0].adresse1,
          ville: doc.docs[i].adresses[0].ville,
          pays: doc.docs[i].adresses[0].pays,
        })
      }
      console.log('clients.length', this.clients.length)
      this.totalRows = this.clients.length
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      if(this.filterInput.length >= 3) {
          this.filter = this.filterInput
      } else {
          this.filter = ''
      }
    },
    applyFilterEnter() {
      this.filter = this.filterInput
    },
    selectedCol(item) {
      this.$router.push({  name: 'viewclient', params: { id: item.key }  })
    }
  },
}
</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
    .per-page-selector {
      width: 90px;
    }
    .btNopadding button {
      padding: 0;
    }
    @media (max-width: 767.98px) {
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        text-align: left;
      }
    }
    table tbody tr {
      height: 60px;
    }
</style>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>
